import { Snackbar } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";

type SnackbarStatus = "success" | "error" | "info" | "warning";

const SnackbarMessage = ({
  open = false,
  message = "設定を保存しました",
  severity = "success",
  handleClose,
}: {
  open: boolean;
  message?: string;
  severity?: SnackbarStatus;
  handleClose?: () => void;
}) => {
  if (!message) {
    return null;
  }

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ horizontal: "right", vertical: "top" }}
      autoHideDuration={5000}
      resumeHideDuration={2000}
      onClose={handleClose}
      style={{ width: "100%" }}
    >
      <Alert onClose={handleClose} variant="filled" severity={severity}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarMessage;
